// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var numericValue = function (value) {
    var numberValue = typeof value === "number" ? value : Number(value);
    return Number.isFinite(numberValue) ? numberValue : 0;
};
export var buildAreaElectionSummaries = function (dataset) {
    return dataset.results_election_area.map(function (electionArea) {
        var contestResults = dataset.results_area_contest.filter(function (contest) {
            return String(contest.election_id) === String(electionArea.election_id) &&
                String(contest.area_id) === String(electionArea.area_id);
        });
        var representativeContest = contestResults.reduce(function (selected, result) {
            if (!selected)
                return result;
            var selectedCensus = numericValue(selected.elegible_census);
            var resultCensus = numericValue(result.elegible_census);
            if (resultCensus !== selectedCensus) {
                return resultCensus > selectedCensus ? result : selected;
            }
            return numericValue(result.total_votes) > numericValue(selected.total_votes)
                ? result
                : selected;
        }, undefined);
        var eligibleCensus = numericValue(representativeContest === null || representativeContest === void 0 ? void 0 : representativeContest.elegible_census);
        var totalVoters = numericValue(representativeContest === null || representativeContest === void 0 ? void 0 : representativeContest.total_votes);
        return __assign(__assign({}, electionArea), { elegible_census: eligibleCensus, total_voters: totalVoters, total_voters_percent: eligibleCensus > 0 ? totalVoters / eligibleCensus : 0 });
    });
};
